// @ts-nocheck
import { unsetDetail } from "~/state/detail/state";
import { store } from "~/state/store";
import { isDetailActive } from "~/util/detail";
import { setCoordinates } from "~/state/map/state";

Mapy.Search.ContextItem = function constructor(label) {
	SMap.Control.ContextMenu.Item.call(this, label);
};

Mapy.Search.ContextItem.prototype = Object.create({ ...SMap.Control.ContextMenu.Item.prototype });

Mapy.Search.ContextItem.prototype.click = function click() {
	if (this._disabled) {
		return;
	}

	const state = store.getState();
	const [longitude, latitude] = this._coords.toWGS84();
	const { zoom } = state.map;

	if (isDetailActive(state)) {
		store.dispatch(unsetDetail());
	}

	Mapy.getComponent("search").activate();
	Mapy.getComponent("search").clearAll();
	store.dispatch(setCoordinates({
		longitude,
		latitude,
		zoom: zoom > 12 ? zoom : 12,
		animate: true,
	}));
	Mapy.getComponent("history").save();
};
